import { render, staticRenderFns } from "./leadsDashboardAllLeads.vue?vue&type=template&id=c2b379e6&scoped=true"
import script from "./leadsDashboardAllLeads.vue?vue&type=script&lang=js"
export * from "./leadsDashboardAllLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b379e6",
  null
  
)

export default component.exports